<template>
  <div>
    <h3 style="text-align:center;">考试管理</h3>
    <el-card style="width: 1300px; margin: 20px auto 0">
      <el-row :gutter="30">
        <el-col :span="5">
          <el-input v-model="keys" placeholder="请输入考试主题" size="medium" clearable
                @keyup.enter.native="searchExam"></el-input>
        </el-col>
        <el-col :span="1.5">
          <el-button type="primary" @click="searchExam" size="medium"
            >查询</el-button
          >
        </el-col>
        <el-col :span="3">
          <el-button type="success" @click="addExamTitle" size="medium"
            >添加考试主题</el-button
          >
        </el-col>
      </el-row>
      <el-table :data="tableExam" style="width: 100%; margin-top: 20px" border>
        <el-table-column prop="title" label="考试主题"> </el-table-column>
        <el-table-column prop="zscore" label="考试总分" width="130px" align="center"> </el-table-column>
        <el-table-column prop="state" label="是否发布" width="130px" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.state"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              @change="changeState(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="updatetime" label="时间" width="130px" align="center">
          <template slot-scope="scope">
            <div>
              {{ scope.row.updatetime.split(" ")[0] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="320px"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
            ></el-button>
            <el-button type="primary" size="mini" @click="handleLog(scope.row)">答题日志</el-button>
            <el-button type="success" size="mini" @click="toExamination(scope.row)">
              管理考试试题
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="isAdd ? '添加考试主题' : '修改考试主题'"
      :visible.sync="dialogExamTitle"
      :width="'800px'"
      :close-on-click-modal="false"
      center
    >
      <div>
        <el-form :model="formExam" label-width="100px">
          <el-form-item label="考试主题：">
            <el-input v-model="formExam.title"></el-input>
          </el-form-item>
          <el-form-item label="考试总分：">
            <el-input v-model.number="formExam.zscore"></el-input>
          </el-form-item>
          <el-form-item label="是否发布：">
            <el-radio-group v-model="formExam.state">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="dialogExamTitle = false">取 消</el-button>
        <el-button type="primary" @click="submitUp">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="答题日志"
      :visible.sync="dialogLog"
      :width="'800px'"
      center
      :close-on-click-modal="false">
      <div>
      <el-table :data="logData" border>
          <el-table-column
            align="center"
            prop="username"
            label="用户名" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="score"
            label="成绩" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="zscore"
            label="总分" >
          </el-table-column>
           <el-table-column
            align="center"
            prop="inserttime"
            label="时间" >
          </el-table-column>
      </el-table>  
      </div>
      <div slot="footer">
        <el-button @click="dialogLog = false">取 消</el-button>
        <el-button type="primary" @click="dialogLog = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isAdd: false,
      keys: "",
      dialogExamTitle: false,
      tableExam: [],
      formExam: {
        title: "",
        zscore: 0,
        state: 0,
      },
      resetForm: {},
      pageIndex: 1,
      pageSize: 20,
      total:0,
      dialogLog:false,
      logIndex:1,
      logSize:20,
      logTotal:0,
      logData:[],
    };
  },
  created() {
    this.resetForm = { ...this.formExam };
    this.getExam();
  },
  methods: {
    // 添加考试主题
    addExamTitle() {
      this.formExam = { ...this.resetForm };
      this.isAdd = true;
      this.dialogExamTitle = true;
    },
    // 确认添加/修改考试主题
    submitUp() {
      if (this.isAdd) {
        this.$http.post("Exam/AddExamTitle", this.formExam).then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.dialogExamTitle = false;
            this.getExam();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$http.post("Exam/UpdateExamTitle", this.formExam).then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.dialogExamTitle = false;
            this.getExam();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    // 查询考试主题按钮
    searchExam() {
      this.pageIndex = 1;
      this.getExam();
    },
    // 获取考试主题
    getExam() {
      this.$http
        .post("Exam/GetSearchList", {
          keys: this.keys,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          action: "getexam",
        })
        .then((res) => {
          if (res.data.isok) {
            this.tableExam = res.data.data;
            this.total=res.data.recount;
          }
        });
    },
    // 上下架考试主题
    changeState(rows) {
      this.$http
        .post("Exam/UpDownExamTitle", {
          state: rows.state,
          examid: rows.examid,
        })
        .then((res) => {
          if (res.data.isok) {
            this.$message.success(res.data.message);
            this.getExam();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 编辑考试主题
    handleEdit(rows) {
      this.isAdd = false;
      this.formExam = { ...this.resetForm };
      this.formExam.title = rows.title;
      this.formExam.zscore = rows.zscore;
      this.formExam.state = rows.state;
      this.formExam.examid = rows.examid;
      this.dialogExamTitle = true;
    },
    // 获取答题日志
    handleLog(rows){
      this.$http.post("Exam/GetSearchList",{
        pageIndex:this.logIndex,
        pageSize:this.logSize,
        action:"getexamlog",
        id:rows.examid
      }).then(res=>{
        if(res.data.isok){
          
          this.logData=res.data.data
          this.dialogLog=true
        }
      })
    },
    // 跳转到考试试题页面
    toExamination(rows){
      this.$router.push({name: 'testQuestions', params: {examid: rows.examid, examTitle: rows.title}})
    },
    // 当页数发生变化时
    handleSizeChange(val){
      this.pageSize=val;
      this.getExam();
    },
    // 当页码发生变化时
    handleCurrentChange(val){
      this.pageIndex=val;
      this.getExam();
    }
  },
};
</script>

<style  lang="less" scoped>
/deep/ button {
  outline: none;
}
/deep/ .el-pagination {
  text-align: center;
  margin-top: 15px;
}
/deep/ .el-table th {
  background-color: #eef1f6;
}
</style>


// WEBPACK FOOTER //
// src/components/Examination.vue